export const CheckboxTick = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 12 10"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-dasharray="16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polyline points="1.5 6 4.5 9 10.5 1" />
    </svg>
  );
};
